module.exports = __webpack_public_path__ + "img/favicon.d6014639.png";